var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreencheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.126,
    y1: 1.25,
    x2: 1.838,
    y2: -1.232,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#103252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73cc2a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_8f19a0b6fde254db12b357c4a3137ce4",
    "data-name": "8f19a0b6fde254db12b357c4a3137ce4",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M24,13A11,11,0,1,1,13,2,11,11,0,0,1,24,13Z",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M16.45,8.981a.788.788,0,0,1,0,1.114L11.2,15.349a.788.788,0,0,1-1.114,0l-2.1-2.1A.788.788,0,1,1,9.1,12.133l1.544,1.544,2.348-2.348,2.348-2.348A.788.788,0,0,1,16.45,8.981Z",
    transform: "translate(0.784 0.835)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreencheck);
export default __webpack_public_path__ + "static/media/greencheck.5a9c38521c3ddd055dcced36cbe91b10.svg";
export { ForwardRef as ReactComponent };